import React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { ILoginPresenter } from "../../presenter/LoginPresenter";
import LoginForm from "../forms/LoginForm";

export interface Props extends PageProps {}
export interface State extends ILoginPresenter {}

export default class LoginPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      login,
      username,
      password,
      loginButtonDisabled,
      setUsername,
      setPassword
    } = this.state;

    return (
      <Page {...this.props}>
        <div className="login-wrapper">
          <LoginForm
            translate={translate}
            username={username}
            password={password}
            login={login}
            loginButtonDisabled={loginButtonDisabled}
            onChangePassword={setPassword}
            onChangeUsername={setUsername}
            loading={this.state.loaders.loginLoader}
          />
        </div>
      </Page>
    );
  }
}
